import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { DescriptionBox, BackButton, DangerousHTMLDiv } from 'ecs-react-components/dist/index.es';
import QuestionnaireContents from './QuestionnaireContents';
import { messages } from './Questionnaires.i18n';
import { loadHistoricalQuestionnaireDetails } from '../../redux/modules/questionnaires/questionnaires-middleware';
import history from '../../history';

class ReviewQuestionnaire extends React.Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(loadHistoricalQuestionnaireDetails(
      this.props.patientId, this.props.questionnaire.assignedQuestionnaireId));
  }

  handleBackButtonClick = () => {
    history.push(this.props.questionnairesOrigin);
  }

  displayDescription = () => {
    const { questionnaire } = this.props;
    const defaultMessageId = 'questionnaire_default_message_' + questionnaire.assignedQuestionnaireId;
    let message = '';
    questionnaire.patientScoreList.map((score) => {
      if (score.patientMessageOnCompletion !== '') {
        message += score.patientMessageOnCompletion + ' <br />';
      }
      return score;
    });

    return (
      <div>
        <p data-qa-item={ defaultMessageId }>
          Questionnaire submitted: {moment(questionnaire.completedDate).format('MMM DD, YYYY')}
        </p>
        <DangerousHTMLDiv qaTag={ defaultMessageId } html={questionnaire.defaultMsgOnCompletion} />
        <DangerousHTMLDiv
          qaTag="questionnaire-score-summary"
          html={ message } className="scoreMessage"
        />
      </div>);
  }

  renderQuestionnaireTitle(title, id) {
    return (
    <div className="row mb-3">
      <div className="col-auto">
        <h1 data-qa-item={id} className="float-left mr-2">{title}</h1>
      </div>
    </div>);
  }
  render() {
    const questionnaireTitleId = 'questionnaire_title_' + this.props.questionnaire.assignedQuestionnaireId;
    return (
      <div>
        <BackButton buttonName={messages.scoring.backButtonText} onClick={this.handleBackButtonClick} />
        {this.renderQuestionnaireTitle(this.props.questionnaire.templateTitle, questionnaireTitleId)}
        <DescriptionBox showPrintButton={ false } content={this.displayDescription()} />
        <QuestionnaireContents disabled questionnaire={this.props.questionnaire} />
      </div>
    );
  }
}

ReviewQuestionnaire.propTypes = {
  questionnaire: PropTypes.object,
  dispatch: PropTypes.func,
  questionnairesOrigin: PropTypes.string,
  patientId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  questionnaire: state.questionnaires
    .historicalQuestionnaires
    .find((q) => q.assignedQuestionnaireId === state.questionnaires.selectedQuestionnaireId),
  questionnairesOrigin: state.questionnaires.questionnairesOrigin,
  patientId: state.profile.patient.patientId,
});

export default connect(mapStateToProps)(ReviewQuestionnaire);
